import React from 'react';
import { SEO } from '../components/shared/SEO';
import { ScrollToTopSection } from './product-complete/ScrollToTopSection';
import { EyebrowSection } from './product-complete/EyebrowSection';
import { HeaderSection } from './product-complete/HeaderSection';
import { ProductHeroSection } from './product-complete/ProductHeroSection';
import { TechSpecsBandSection } from './product-complete/TechSpecsBandSection';
import { PressureControlSection } from './product-complete/PressureControlSection';
import { WhatsIncludedSection } from './product-complete/WhatsIncludedSection';
import { TechnicalSpecsSection } from './product-complete/TechnicalSpecsSection';
import { WhyChooseSection } from './product-complete/WhyChooseSection';
import { WhoItsForSection } from './product-complete/WhoItsForSection';
import { FinalCTASection } from './product-complete/FinalCTASection';
import { FooterSection } from './product-complete/FooterSection';
export function ProductCompleteKit() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-935">
      <ScrollToTopSection data-id="element-936" />
      <SEO title="ForceX Complete Kit | Precision Pro Sprayers" description="Out of the box, ready to work. Includes enclosed system housing for maximum efficiency and cleanliness." data-id="element-937" />
      <EyebrowSection data-id="element-938" />
      <HeaderSection data-id="element-939" />
      <main className="flex-grow" data-id="element-940">
        <ProductHeroSection data-id="element-941" />
        <TechSpecsBandSection data-id="element-942" />
        <PressureControlSection data-id="element-943" />
        <WhatsIncludedSection data-id="element-944" />
        <TechnicalSpecsSection data-id="element-945" />
        <WhyChooseSection data-id="element-946" />
        <WhoItsForSection data-id="element-947" />
        <FinalCTASection data-id="element-948" />
      </main>
      <FooterSection data-id="element-949" />
    </div>;
}